














































































































import Vue from "vue";
import { v4 as uuidv4 } from "uuid";
import iwModal from "@/shared/components/Modal.vue";
import iwButtonLoading from "@/shared/components/ButtonLoading.vue";
import iwDeactivateReasonSoldOrRented from "@/myImmoweb/deactivation/DeactivateReasonSoldOrRented.vue";
import iwDeactivateReasonOther from "@/myImmoweb/deactivation/DeactivateReasonOther.vue";
import iwDeactivateReasonFraud from "@/myImmoweb/deactivation/DeactivateReasonFraud.vue";

import { deactivateClassified } from "@/shared/scripts/ClassifiedsApi";
import { ClassifiedDeactivationReason, Reason } from "@/shared/interfaces/ClassifiedDeactivationReason.interface";
import { mapGetters } from "vuex";
import { i18n } from "@/shared/scripts/helpers/translation/i18n";
import { AxiosError } from "node_modules/axios";

export default Vue.extend({
    components: {
        iwButtonLoading: iwButtonLoading,
        iwDeactivateReasonSoldOrRented: iwDeactivateReasonSoldOrRented,
        iwDeactivateReasonOther: iwDeactivateReasonOther,
        iwDeactivateReasonFraud: iwDeactivateReasonFraud,
        iwModal: iwModal,
    },

    data: function() {
        return {
            isCorrectlyDeactivated: false,
            isLoading: false,
            specificId: uuidv4() as string,
            name: "radioGroupWithSubfieldsInAccordion",
            errorMessage: false,
            reason: {} as ClassifiedDeactivationReason,
        };
    },

    computed: {
        ...mapGetters({
            isMasquerading: "UserModule/isMasquerading"
        }),
        isDeactivateModalOpen: function(): boolean {
            return this.$store.getters["ModalModule/isDeactivateModalOpen"];
        },
        isSoldOrRented: function(): boolean {
            return (this.reason.type as unknown) == "SOLD_OR_RENTED";
        },
        descriptionPhrases: function(): string[] {
            const text = this.$t("classified_deactivation_confirmation_text") as string;
            return text.split(/\\n/) as string[];
        },
    },

    methods: {
        closeDeactivateModal: function(): void {
            this.isCorrectlyDeactivated = false;
            this.updateReason();
            this.$store.commit("ModalModule/closeDeactivateModal");
        },

        openDeactivateModal: function(): void {
            this.$store.commit("ModalModule/openDeactivateModal");
            this.$store.commit("MyClassifiedsModule/resetClassifiedApiErrors");
        },

        updateReason: function(reason: ClassifiedDeactivationReason | Reason = {}): void {
            if (typeof reason === "string") {
                reason = { type: reason };
            }
            this.reason = reason as ClassifiedDeactivationReason;
        },

        deactivateClassifiedCall: function(): void {
            this.isLoading = true;

            deactivateClassified(this.reason).then((responseStatus: boolean) => {
                this.isLoading = false;
                this.isCorrectlyDeactivated = responseStatus;

                if (responseStatus) {
                    this.$emit("deactivate");
                }
            }).catch((error: AxiosError) => {
                if(error.response?.status !== 400) {
                    this.dialog.alert(i18n.t("server_not_responding_error").toString());
                }
                this.isLoading = false;
                console.error(error);
            });

            this.$store.commit("MyClassifiedsModule/resetClassifiedApiErrors");

        }
    },
});

